<template>
  <div class="page-login">
    <div class="background"></div>
    <el-card id="wrap_box_card">
      <p class="page-title">{{ $t('login.manageSystem') }}</p>
      <el-card class="box-card" :body-style="{ padding: '0px' }">
        <el-col :span="24" class="input-row">
          <el-row class="img-row">
            <el-image :src="logo" fit="contain"></el-image>
          </el-row>

          <el-row>
            <el-form ref="form" @submit.native.prevent="handleLogin">
              <!-- 阻止浏览器自动填充 -->
              <template v-if="!rememberPass">
                <input name="loginName" type="text" style="position: absolute; top: -999px;" />
                <input name="password" type="password" style="position: absolute; top: -999px;" />
              </template>

              <el-input v-model="loginName" required :placeholder="$t('login.inputEmail')" autocomplete="on"></el-input>

              <div style="margin: 10px 0;"></div>
              <el-input
                v-model="password"
                required
                :type="password"
                show-password
                :placeholder="$t('login.inputPassword')"
                autocomplete="off"
              ></el-input>
              <div style="margin: 10px 0;"></div>

              <el-form-item label-width="56px" style="margin-bottom:10px">
                <el-checkbox v-model="rememberPass" @change="handleRememberPassChange">{{ $t('login.remenberPassword') }}</el-checkbox>
              </el-form-item>

              <div style="margin: 12px 0;"></div>
              <el-row justify="center" size="medium">
                <el-button type="primary" native-type="submit" class="submit-btn">{{ $t('login.login') }}</el-button>
              </el-row>

              <el-row justify="center" style="margin: 10px 0;">
                <!-- <router-link :to="'register'">{{ $t('login.signUp') }}</router-link> | -->
                <router-link :to="'password'">{{ $t('login.forgetPassword') }}</router-link>
              </el-row>
            </el-form>
          </el-row>
        </el-col>
      </el-card>
    </el-card>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import Sidebar from './welcome';
  import { TOKEN_STORAGE_KEY, REMENBER_PASSWORD_SWITCH_STORAGE_KEY } from '@/constants';
  import _ from 'lodash';

  @Component({ components: { Sidebar } })
  export default class Login extends Vue {
    loginName = '';
    password = '';
    rememberPass = false;
    logo = require('@/assets/logo-title.png')

    created() {
      this.rememberPass = Boolean(+localStorage.getItem(REMENBER_PASSWORD_SWITCH_STORAGE_KEY));
    }

    async handleLogin() {
      const { admin_user, token } = await this.$autoLoading(
        this.$request.post('/sessions', {
          login_name: this.loginName,
          password: this.password,
        })
      );

      localStorage.setItem(TOKEN_STORAGE_KEY, token);
      localStorage.setItem('currentRoleId', _.get(admin_user.current_role, 'id'));
      this.$message.success(this.$t('login.loginSuccess'));
      if (this.$route.query.redirect) {
        this.$router.replace(decodeURI(this.$route.query.redirect));
      } else {
        this.$router.replace({ name: 'home' });
      }
    }

    handleRememberPassChange(e) {
      localStorage.setItem(REMENBER_PASSWORD_SWITCH_STORAGE_KEY, +e);
    }
  }
</script>

<style lang="scss">
.page-login {
  width: 100%;
  height: 100%;
  background-color: $primary;
  svg linearGradient stop {
    stop-color: #17E890;
  }
  .background-color {
    fill: #17E890;
  }
  .background {
    top: 50%;
    left: 50%;
    overflow: hidden;
    position: absolute;
    transform: translate(-50%, -50%);
  }
  #wrap_box_card {
    top: 48%;
    left: 50%;
    width: 400px;
    position: absolute;
    text-align: center;
    box-shadow: none;
    border-style: none;
    outline-color: transparent;
    -webkit-box-shadow: none;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    background-color: rgba(255, 255, 255, 0.0);
    .page-title {
      color: #ffffff;
      font-size: 20px;
    }
    .box-card {
      border-style: none;
      .img-row {
        font-size: 24px;
        margin: 15px 0 5px;
        font-weight: bold;

        img {
          width: 135px;
        }
      }
      .submit-btn {
        width: 250px;
        height: 44px;
        border: none;
        font-size: 15px;
      }

      .el-form-item__content {
        text-align: left;
      }

      .el-input {
        width: 250px;
      }
    }
  }

  a.captcha-img-wrapper:hover:after {
    border-bottom: initial;
  }

  .captcha-img-wrapper {
    img {
      width: 100px;
      height: 35px;
      margin-left: 10px
    }
  }
}
</style>
